import type { ReactNode, JSX } from 'react'

import { clsx } from 'clsx'

import { Tooltip, InfoIcon } from '@buffer-mono/popcorn'
import type { TooltipProps } from '@buffer-mono/popcorn'

import styles from './PostTypeBarView.module.css'

export type PostTypeBarOption = {
  value: string
  name: string
  disabled?: boolean
  disabledMessage?: string
}

export type PostTypeBarViewProps = {
  name: string
  postTypes: PostTypeBarOption[]
  value: string
  onChange: (newValue: string, input: HTMLInputElement) => void
  tooltip?: ReactNode
  inputIdPrefix?: string
}

const TooltipWrapper = ({ ...props }: TooltipProps): JSX.Element => {
  if (!props.content) {
    return <>{props.children}</>
  }
  return <Tooltip {...props} />
}

export const PostTypeBarView = ({
  name,
  postTypes,
  value,
  onChange,
  tooltip,
  inputIdPrefix = '',
}: PostTypeBarViewProps): JSX.Element => (
  <div className={styles.postTypeWrapper}>
    <div>
      {postTypes.map((postType) => {
        const inputId = `${inputIdPrefix}${postType.value}`

        return (
          <TooltipWrapper
            key={postType.value}
            content={postType.disabled ? postType.disabledMessage : ''}
          >
            <label
              className={clsx(
                styles.radioLabel,
                postType.disabled && styles.disabled,
              )}
              htmlFor={inputId}
            >
              <input
                className={styles.radioInput}
                type="radio"
                id={inputId}
                name={name}
                value={postType.value}
                checked={value === postType.value}
                onChange={(e): void => onChange(e.target.value, e.target)}
                disabled={postType.disabled}
                aria-label={postType.name}
              />
              {postType.name}
            </label>
          </TooltipWrapper>
        )
      })}
    </div>
    <div>
      {tooltip && (
        <Tooltip side="left" content={tooltip}>
          <InfoIcon className="info-icon-wrapper" />
        </Tooltip>
      )}
    </div>
  </div>
)
